import React, { useEffect, useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { exceptionTypeLabels, moduleLabels, sourceLabels } from '../../data/labels';
import { ModuleKey } from '../../types/family';
import { formatTimeOfDay } from '../../utils/time';
import { Button } from '../ui/Button';
import { Field, Toggle } from '../ui/Form';
import { EmptyNote } from '../ui/Panel';
export function CalendarSettings() {
  const {
    family,
    toggleCalendar,
    addCalendar,
    updateRulesNow
  } = useAppState();
  const [name, setName] = useState('');
  const v = family.rules.visibility;
  return <div className="space-y-6" data-id="element-637" data-mp="2exrnpm8rdgrg">
      <section data-id="element-638" data-mp="2izlhdakjdki4">
        <h3 className="font-display text-lg font-semibold" data-id="element-639" data-mp="2iz3cxqnpzzz4">Povezani koledarji</h3>
        <p className="text-xs text-muted" data-id="element-640" data-mp="36pfwjysbvl5j">V prototipu so viri vzorčni – Google računi še niso povezani in dogodki niso prebrani.</p>
        <ul className="mt-2 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface px-4" data-id="element-641" data-mp="3bgxwqkmj1hpg">
          {family.calendars.length === 0 && <li className="py-3 text-sm text-muted" data-id="element-642" data-mp="864cwchf6yus">Ni povezanih virov.</li>}
          {family.calendars.map(c => <li key={c.id} data-id="element-643" data-mp="hy0c5qv8sv0l">
              <Toggle checked={c.status === 'vzorec'} onChange={() => toggleCalendar(c.id)} label={c.name} hint={`${sourceLabels[c.source]} · samo za branje · uvoženi dogodki se ne podvajajo`} data-id="element-644" data-mp="hya0la0n2u46" />
            </li>)}
        </ul>
        <form className="mt-2 flex gap-2" onSubmit={e => {
        e.preventDefault();
        if (name.trim()) addCalendar(name.trim());
        setName('');
      }} data-id="element-645" data-mp="qwvgsyin1x1s">
          <input className="field" aria-label="Ime vira" placeholder="Dodaj vir (npr. Šolski koledar)" value={name} onChange={e => setName(e.target.value)} data-id="element-646" data-mp="10urzcbdwnu9x" />
          <Button type="submit" variant="secondary" disabled={!name.trim()} data-id="element-647" data-mp="32palxum6a1ro">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-648" data-mp="2xpo93ma9anje" /> Vir
          </Button>
        </form>
      </section>
      <section data-id="element-649" data-mp="11n1m3qjyprsd">
        <h3 className="font-display text-lg font-semibold" data-id="element-650" data-mp="11nkry8wc8pq1">Vidnost v družini</h3>
        <div className="mt-2 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface px-4" data-id="element-651" data-mp="16m4fgdqky9ki">
          <Toggle checked={v.calendarAll} onChange={x => updateRulesNow({
          visibility: {
            ...v,
            calendarAll: x
          }
        }, 'Zasebnost', `Koledar vseh: ${x ? 'da' : 'ne'}`)} label="Vsi vidijo vse koledarske dogodke" hint="S filtri po članih. Vidnost ne pomeni pravice urejanja." data-id="element-652" data-mp="1alwrx1j3gzv5" />
          <Toggle checked={v.personalParentsOnly} onChange={x => updateRulesNow({
          visibility: {
            ...v,
            personalParentsOnly: x
          }
        }, 'Zasebnost', `Šolski TODO in dnevnik samo član + skrbniki: ${x ? 'da' : 'ne'}`)} label="Šolski TODO in dnevnik časa vidijo samo član in skrbniki" data-id="element-653" data-mp="1pjfb7od06kv7" />
        </div>
      </section>
    </div>;
}
export function EveningSettings() {
  const {
    family,
    updateRulesNow
  } = useAppState();
  const [e, setE] = useState(family.rules.evening);
  useEffect(() => setE(family.rules.evening), [family.rules.evening]);
  const dirty = JSON.stringify(e) !== JSON.stringify(family.rules.evening);
  if (!family.modules.vecerniRezim) return <EmptyNote data-id="element-654" data-mp="2ddzbd35sxllt">Večerni režim je izklopljen. Vklopiš ga v Opomniki in moduli.</EmptyNote>;
  return <div className="space-y-6" data-id="element-655" data-mp="28gh6bnuwnqj3">
      <section data-id="element-656" data-mp="24evn7krs2g0g">
        <h3 className="font-display text-lg font-semibold" data-id="element-657" data-mp="24fdt7948s8lk">Pravila večera</h3>
        <div className="mt-3 grid gap-3 sm:grid-cols-3" data-id="element-658" data-mp="314lgomof8rs4">
          <Field label="Pred šolskim dnem: v sobi" data-id="element-659" data-mp="314cziil9n0b4">{id => <input id={id} className="field" value={e.schoolNightRoom} onChange={x => setE({
            ...e,
            schoolNightRoom: x.target.value
          })} data-id="element-660" data-mp="2w61po7uz0psw" />}</Field>
          <Field label="Pet/sob: v sobi (zaželeno)" data-id="element-661" data-mp="2rdigro78aiuf">{id => <input id={id} className="field" value={e.weekendRoom} onChange={x => setE({
            ...e,
            weekendRoom: x.target.value
          })} data-id="element-662" data-mp="2ndq16rjf3cfk" />}</Field>
          <Field label="Pet/sob: spanje (obvezno)" data-id="element-663" data-mp="3jw5vmlvmt1n2">{id => <input id={id} className="field" value={e.weekendSleep} onChange={x => setE({
            ...e,
            weekendSleep: x.target.value
          })} data-id="element-664" data-mp="3f4nvu15ch73o" />}</Field>
        </div>
        <div className="mt-3" data-id="element-665" data-mp="2zl1ny9phte68">
          <Field label="Kam se odložijo naprave" data-id="element-666" data-mp="2zozaz6f6ypve">{id => <input id={id} className="field" value={e.devicesPlace} onChange={x => setE({
            ...e,
            devicesPlace: x.target.value
          })} data-id="element-667" data-mp="34mr0xuwa01wy" />}</Field>
        </div>
        {dirty && <Button className="mt-3" onClick={() => updateRulesNow({
        evening: e
      }, 'Večerni režim', `V sobi ${e.schoolNightRoom}, vikend ${e.weekendRoom}/${e.weekendSleep}`)} data-id="element-668" data-mp="2un9v9dh0xo0z">
            Shrani večer
          </Button>}
      </section>
      <section data-id="element-669" data-mp="3nbpaa005o6cb">
        <h3 className="font-display text-lg font-semibold" data-id="element-670" data-mp="3nbflugure78q">Vrste izjem</h3>
        <ul className="mt-2 flex flex-wrap gap-2" data-id="element-671" data-mp="39k10w4hajvz1">
          {Object.values(exceptionTypeLabels).map(l => <li key={l} className="rounded-full bg-canvas px-3 py-1.5 text-sm font-bold" data-id="element-672" data-mp="3dkuk4kjsgmll">
              {l}
            </li>)}
        </ul>
        <p className="mt-2 text-xs text-muted" data-id="element-673" data-mp="9x2hfw29x9wo">Otrok izjemo predlaga, skrbnik jo potrdi ali doda neposredno (Pregled › član › Dodaj izjemo).</p>
      </section>
    </div>;
}
export function ModulesSettings() {
  const {
    family,
    toggleModule,
    updateRulesNow
  } = useAppState();
  const [rem, setRem] = useState(family.rules.reminders);
  useEffect(() => setRem(family.rules.reminders), [family.rules.reminders]);
  return <div className="space-y-6" data-id="element-674" data-mp="1zfher817filf">
      <section data-id="element-675" data-mp="1zf7xc8u86jrc">
        <h3 className="font-display text-lg font-semibold" data-id="element-676" data-mp="1zgsjpb6dywe4">Moduli</h3>
        <p className="text-xs text-muted" data-id="element-677" data-mp="1bpdm1vpk1397">Izklopljen modul nima obveznosti – družina brez živali nima oskrbe.</p>
        <div className="mt-2 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface px-4" data-id="element-678" data-mp="16rvcq47mkm0o">
          {(Object.keys(moduleLabels) as ModuleKey[]).map(k => <Toggle key={k} checked={family.modules[k]} onChange={() => toggleModule(k)} label={moduleLabels[k].label} hint={moduleLabels[k].hint} data-id="element-679" data-mp="1gn5c0k6n2far" />)}
        </div>
      </section>
      <section data-id="element-680" data-mp="2s228ug92e8so">
        <h3 className="font-display text-lg font-semibold" data-id="element-681" data-mp="2s2lmhkromb0w">Opomniki</h3>
        <div className="mt-3 grid gap-3 sm:grid-cols-2" data-id="element-682" data-mp="2z73dqnr58p78">
          <Field label="Pregled preostalih nalog ob" data-id="element-683" data-mp="2z8o92fla8c65">{id => <input id={id} className="field" value={rem.dailySummary} onChange={e => setRem({
            ...rem,
            dailySummary: e.target.value
          })} data-id="element-684" data-mp="3443hgs0itfv6" />}</Field>
          <Field label="Večerna rutina – minut pred rokom" data-id="element-685" data-mp="392n6x2ebp9sa">
            {id => <input id={id} type="number" min={0} className="field" value={rem.eveningMinutesBefore} onChange={e => setRem({
            ...rem,
            eveningMinutesBefore: Number(e.target.value)
          })} data-id="element-686" data-mp="3e32jhrqs6d97" />}
          </Field>
        </div>
        {JSON.stringify(rem) !== JSON.stringify(family.rules.reminders) && <Button className="mt-3" onClick={() => updateRulesNow({
        reminders: rem
      }, 'Opomniki', `Pregled ob ${rem.dailySummary}, večer ${rem.eveningMinutesBefore} min prej`)} data-id="element-687" data-mp="2qcf82whnp5hw">
            Shrani opomnike
          </Button>}
        <p className="mt-2 text-xs text-muted" data-id="element-688" data-mp="1xnhxlfjosczp">Prava potisna obvestila bodo preverjena v Android aplikaciji.</p>
      </section>
    </div>;
}
export function HistorySettings() {
  const {
    db,
    family,
    memberById,
    applyScheduled
  } = useAppState();
  const list = db.changelog.filter(c => c.familyId === family.id);
  if (list.length === 0) return <EmptyNote data-id="element-689" data-mp="arjvv3eltkk7">Še ni sprememb. Vsaka sprememba se zapiše tukaj s časom in veljavnostjo.</EmptyNote>;
  return <ul className="divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-690" data-mp="5sqg14buhhgv">
      {list.map(c => <li key={c.id} className="flex flex-wrap items-center gap-3 px-4 py-3" data-id="element-691" data-mp="vq9ytezwepr">
          <span className="min-w-0 flex-1" data-id="element-692" data-mp="3s8b7tc5b5v88">
            <span className="block text-sm font-bold" data-id="element-693" data-mp="3o7iw8c8yre8s">{c.text}</span>
            <span className="block text-xs text-muted" data-id="element-694" data-mp="3o7r7jzpfubhv">
              {c.area} · {memberById(c.by)?.name ?? 'skrbnik'} ob {formatTimeOfDay(c.at)} · {c.effective === 'takoj' ? 'velja takoj' : 'velja od 12. 10.'}
            </span>
          </span>
          {c.status === 'nacrtovano' ? <Button size="sm" variant="secondary" onClick={() => applyScheduled(c.id)} data-id="element-695" data-mp="39as48o1md4t7">
              Simuliraj začetek tedna
            </Button> : <span className="rounded-full bg-done-soft px-2 py-0.5 text-xs font-bold text-done-ink" data-id="element-696" data-mp="16157sk2vh7m4">Uveljavljeno</span>}
        </li>)}
    </ul>;
}